import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.75 4v16a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 1.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m7.604 14.556.002.003.007.01.03.04a32 32 0 0 0 .544.711c.361.463.854 1.077 1.385 1.689.535.615 1.093 1.212 1.587 1.648q.374.33.635.486c.113.068.179.093.206.103a1 1 0 0 0 .206-.103 4.6 4.6 0 0 0 .634-.486c.494-.436 1.053-1.033 1.588-1.648a43 43 0 0 0 1.929-2.4l.03-.04.007-.01.002-.003a.75.75 0 0 1 1.208.89L17 15l.604.444-.012.016-.032.044-.122.162a46 46 0 0 1-1.878 2.325c-.55.635-1.16 1.288-1.726 1.79a6 6 0 0 1-.854.646c-.26.157-.607.322-.98.322-.374 0-.72-.165-.98-.322a6 6 0 0 1-.854-.647c-.567-.5-1.176-1.154-1.727-1.789a44 44 0 0 1-1.999-2.487l-.032-.044-.009-.011-.003-.004L7 15l-.604.445a.75.75 0 0 1 1.208-.89",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }